
import React from 'react';
import PageLayout from '@/components/PageLayout';
import AdBanner from '@/components/AdBanner';
import { useUserData } from '@/hooks/use-user-data';
import { useOnboardingContext } from '@/context/OnboardingContext';
import AdRequestHero from '@/components/forms/AdRequestHero';
import AdRequestInfoCards from '@/components/forms/AdRequestInfoCards';
import AdRequestSteps from '@/components/forms/AdRequestSteps';
import AdRequestLoadingState from '@/components/forms/AdRequestLoadingState';
import AdRequestErrorState from '@/components/forms/AdRequestErrorState';
import logo from '/lovable-uploads/40a4ee59-7714-4091-a6f7-e5ba5819fe5f.png';
import { useTranslation } from 'react-i18next';

const AdRequest = () => {
  const { userData: onboardingData, isLoading: onboardingLoading } = useOnboardingContext();
  const { userData, isLoading, error } = useUserData();
  const { t } = useTranslation();

  console.log('AdRequest page - onboardingData:', onboardingData);
  console.log('AdRequest page - onboardingLoading:', onboardingLoading);
  console.log('AdRequest page - userData:', userData);
  console.log('AdRequest page - isLoading:', isLoading);
  console.log('AdRequest page - error:', error);

  // Show loading if either onboarding or user data is loading
  if (isLoading || onboardingLoading) {
    return (
      <PageLayout
        title={t('adRequest.title')}
        logo={logo}
        showBackButton={true}
        backButtonPath="/"
      >
        <AdRequestLoadingState />
      </PageLayout>
    );
  }

  if (error) {
    return (
      <PageLayout
        title={t('adRequest.title')}
        logo={logo}
        showBackButton={true}
        backButtonPath="/"
      >
        <AdRequestErrorState error={error} />
      </PageLayout>
    );
  }

  // If we have onboarding data but no converted user data, try to use onboarding data directly
  const displayUserData = userData || (onboardingData && onboardingData.onboardingCompleted ? {
    id: onboardingData.email || '',
    name: onboardingData.name || '',
    email: onboardingData.email || '',
    phone_number: onboardingData.phoneNumber || ''
  } : null);

  if (!displayUserData) {
    return (
      <PageLayout
        title={t('adRequest.title')}
        logo={logo}
        showBackButton={true}
        backButtonPath="/"
      >
        <AdRequestErrorState error={t('adRequest.loadingUserData')} />
      </PageLayout>
    );
  }

  return (
    <PageLayout
      title={t('adRequest.title')}
      logo={logo}
      showBackButton={true}
      backButtonPath="/"
    >
      {/* Ad Banner for ad-request page */}
      <AdBanner pageSlug="ad-request" />
      
      <div className="max-w-2xl mx-auto space-y-6">
        <AdRequestHero userData={displayUserData} />
        <AdRequestInfoCards />
        <AdRequestSteps />
      </div>
    </PageLayout>
  );
};

export default AdRequest;
